import React, { useState, useEffect } from 'react';
import { Grid, Box, Tabs, Tab } from '@mui/material';
import { useDispatch } from 'react-redux';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import ImageUpload from './ImageUpload';
import ImageList from './ImageList';

const ImagePage = () => {
    const menuDispatch = useDispatch();
    const [currentTab, setCurrentTab] = useState('all');
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'media-image'
        });
    }, [menuDispatch]);

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const handleUploadSuccess = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <>
            <PageHeaderLayout headerTitle={'Image Management'}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs 
                        value={currentTab} 
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTab-root': {
                                fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.85rem' },
                                minHeight: { xs: 40, md: 48 },
                                padding: { xs: '6px 12px', md: '12px 16px' }
                            }
                        }}
                    >
                        <Tab label="All Images" value="all" />
                        <Tab label="WhatsApp" value="whatsapp" />
                    </Tabs>
                </Box>
            </PageHeaderLayout>

            <Grid container spacing={2} sx={{ mt: 1 }}>
                {/* Upload Section */}
                <Grid item xs={12} md={5}>
                    <ImageUpload onUploadSuccess={handleUploadSuccess} currentTab={currentTab} />
                </Grid>

                {/* List Section */}
                <Grid item xs={12} md={7}>
                    <ImageList refreshTrigger={refreshTrigger} currentTab={currentTab} />
                </Grid>
            </Grid>
        </>
    );
};

export default ImagePage;
